module.exports = {"somethingWentWrong":"Something went wrong.","priceNote":"*A service fee will be added to this transaction.","getDirections":"Get directions","presentedBy":"Presented by","salesStart":"Public Sales Start: ","presaleStart":"Presale Starts: ","notAvailable":"Online Sales Ended","publicSaleEnded":"Public sales ended","unlock":"Unlock","unlocked":"Unlocked!","presale":"In presale"}


//////////////////
// WEBPACK FOOTER
// ./src/components/EventLanding/locales/en.json
// module id = 1791
// module chunks = 0